<app-filter-table (resetPaginator)="resetPaginator()" #filter></app-filter-table>
<app-data-table [catalogs]="filter.catalogs"></app-data-table>
<app-impaired-pagination (paginatorChanged)="filter.paginatorChanged($event)" #paginator [allCount]="(allCatalogCount$ | async) ?? 0"></app-impaired-pagination>
